import { render, staticRenderFns } from "./NavbarHomeIcon.vue?vue&type=template&id=2dc50c47&"
import script from "./NavbarHomeIcon.vue?vue&type=script&lang=ts&"
export * from "./NavbarHomeIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2dc50c47', component.options)
    } else {
      api.reload('2dc50c47', component.options)
    }
    module.hot.accept("./NavbarHomeIcon.vue?vue&type=template&id=2dc50c47&", function () {
      api.rerender('2dc50c47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/NavbarHomeIcon.vue"
export default component.exports